import { wishlist_updated } from "@/utils/gtm";

// wishlistReducer.js
const wishlistReducer = (state, action) => {
  switch (action.type) {
    case "get_wl":
      return (state = action?.payload);
    case "add_wl":
      const item = action.payload;
      wishlist_updated([...Object.values(state || {}), item]);
      return { ...state, [item?.sku]: item };

    case "remove_wl":
      const newState = { ...state };
      delete newState[action.payload];
      wishlist_updated(Object.values(newState || {}));
      return newState;

    default:
      return state;
  }
};

export default wishlistReducer;
